import api from '~/services/api';
import { RequestData, ResponseMessage } from '../types';

export const romaneioServices = {
  getAjustes: async (): Promise<ResponseMessage> => {
    try {
      const { data } = await api.get('/tipoajusteestoque/tipos-romaneio');
      return data;
    } catch (err: any) {
      return err.data;
    }
  },

  getUnidades: async (): Promise<ResponseMessage> => {
    try {
      const { data } = await api.get('/unidade');
      return data;
    } catch (err: any) {
      return err.data;
    }
  },

  getProductsData: async (
    cod_produto: string,
    cod_loja: number,
    cod_fornecedor: number,
  ): Promise<ResponseMessage> => {
    try {
      const { data } = await api.get(
        `/romaneio-fornecedor/getProductsData/${cod_produto}/${cod_loja}/${cod_fornecedor}`,
      );
      return data;
    } catch (err: any) {
      return err.data;
    }
  },

  getProductPai: async (
    cod_associado: string,
    cod_loja: number,
  ): Promise<ResponseMessage> => {
    try {
      const { data } = await api.get(
        `/produto/busca-pai/${cod_associado}/${cod_loja}`,
      );
      return data;
    } catch (err: any) {
      return err.data;
    }
  },

  gravarAjuste: async (requestData: RequestData): Promise<ResponseMessage> => {
    try {
      const { data } = await api.post('/romaneiro-fornecedor', requestData);
      return data;
    } catch (err: any) {
      return err.data;
    }
  },

  cancelarAjuste: async (cod_ajuste: number): Promise<ResponseMessage> => {
    try {
      const { data } = await api.delete(`/romaneiro-fornecedor/${cod_ajuste}`);
      return data;
    } catch (err: any) {
      return err.data;
    }
  },
};
